import axios from "axios";
import { backUrl } from "./Urls";
import { setupApiInterceptor } from "./interceptor";

const Api = axios.create({
  baseURL: backUrl + "/",
  timeout: 60000,
});

setupApiInterceptor(Api, "main");

export default Api;
